import Vue from 'vue';

import './modules/enso/';

import router from './router';
import store from './store';
import App from './core/App.vue';
import VModal from 'vue-js-modal'

import './app';

new Vue({
    router,
    store,
    ...App,
}).$mount('#app');

Vue.use(VModal, { componentName: "v-modal" })


// WEBPACK FOOTER //
// ./resources/js/enso.js